import {usePage} from "@inertiajs/inertia-react";
import {useEffect, useRef} from "react";
import i18n from 'i18next';

export default function OrgSwitcher() {
    const appAndOrgSwitcher = useRef();
    const currentOrganization = usePage().props.auth.current_organization;
    var isRendering = false;

    useEffect(() => {
            // Add the app and org switcher script tag 1 time after React has finished rendering the DOM
            if (!isRendering) {
                isRendering = true;
                let switcherScript = document.createElement('script');
                switcherScript.id = 'appAndOrgSwitcherScript';
                //TODO: should really use switcher/appAndOrgSwitcher.js as src but this
                //TODO: requires change on each server script to replace "localhost" in file with server address
                switcherScript.src = '/orgSwitcher/orgSwitcher.js';
                switcherScript.dataset.uuid = currentOrganization.uuid;
                switcherScript.dataset.currentOrgName = currentOrganization.name;
                switcherScript.dataset.selected = 'Home';
                switcherScript.dataset.lang = i18n.language;
                switcherScript.dataset.fixed = 'true';
                switcherScript.dataset.haveRequiredFonts = 'true';
                appAndOrgSwitcher.current.appendChild(switcherScript);
            }
        }, []);

        return <>
            <div ref={appAndOrgSwitcher}>
            </div>
        </>

}
